module.exports = __webpack_public_path__ + "static/media/043-edit.e866cb4d.svg";